"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPalette = void 0;
var createPalette_1 = __importDefault(require("@material-ui/core/styles/createPalette"));
exports.createPalette = function () {
    return createPalette_1.default({
        primary: {
            50: "#EBF1FB",
            100: "#D7E4F6",
            200: "#B8CFF0",
            300: "#9ABBEA",
            400: "#72A0E1",
            500: "#3577D4",
            600: "#2967BF",
            700: "#2358A4",
            800: "#1C4783",
            900: "#173B6D",
            lighter: "#EBF1FB",
            main: "#3577D4",
        },
        secondary: {
            50: "#F5ECFC",
            100: "#EADAF8",
            200: "#DBBEF3",
            300: "#CCA2EE",
            400: "#B77DE7",
            500: "#9846DD",
            600: "#8728D7",
            700: "#7422B8",
            800: "#601C9A",
            900: "#4D177B",
            lighter: "#F3EBFA",
            main: "#9846DD",
        },
        error: {
            50: "#FEECEB",
            100: "#FFCDD2",
            200: "#EF9A9A",
            300: "#E57373",
            400: "#EF5350",
            500: "#F44336",
            600: "#E53935",
            700: "#D32F2F",
            800: "#C62828",
            900: "#B71C1C",
            lighter: "#FAECEB",
            main: "#F44336",
        },
        warning: {
            50: "#FFF3E0",
            100: "#FFE0B2",
            200: "#FFCC80",
            300: "#FFB74D",
            400: "#FFA726",
            500: "#FF9800",
            600: "#FB8C00",
            700: "#F57C00",
            800: "#EF6C00",
            900: "#E65100",
            lighter: "#FAF2EB",
            main: "#FF9800",
        },
        info: {
            lighter: "#EBF1FB",
            main: "#3577D4",
        },
        success: {
            50: "#E8F5E9",
            100: "#C8E6C9",
            200: "#A5D6A7",
            300: "#81C784",
            400: "#66BB6A",
            500: "#4CAF50",
            600: "#43A047",
            700: "#388E3C",
            800: "#2E7D32",
            900: "#1B5E20",
            lighter: "#EBFAEF",
            main: "#4CAF50",
        },
        neutral: {
            50: "#F5F5F6",
            100: "#E5E7E8",
            200: "#D6D8DB",
            300: "#C6CACD",
            400: "#B7BBBF",
            500: "#989EA4",
            600: "#6F777E",
            700: "#4A4F54",
            800: "#25282A",
            900: "#131415",
            main: "#989EA4",
            grey95: "#EBEEF2",
            grey90: "#D3DBE6",
            grey60: "#8D9299",
            grey36: "#434D5C",
            darkBlue: "#0F2440",
        },
        common: {
            black: "#000000",
            white: "#FFFFFF",
        },
    });
};
